<template>
  <pt-hospital-table class="pt-hospital-table__page"></pt-hospital-table>
</template>

<script>
import PtHospitalTable from 'cps/hospital-and-doctor-manage/pt-hospital-manage/pt-hospital-table/withData'
export default {
  name: 'pt-hospital-table__view',
  components: {
    'pt-hospital-table': PtHospitalTable
  }
}
</script>
